import React from 'react';

const TuneupLogo = ({ className = 'w-8 h-8' }) => (
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" className={className}>
    <defs>
      <linearGradient id="ttGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#dc2626" />
        <stop offset="100%" stopColor="#ea580c" />
      </linearGradient>
    </defs>
    {/* T horizontal bar */}
    <rect x="6" y="9" width="20" height="4" fill="url(#ttGrad)" rx="0.5" opacity="0.9" />
    {/* T vertical stem */}
    <rect x="14" y="9" width="4" height="14" fill="url(#ttGrad)" rx="0.5" opacity="0.9" />
    {/* Connection dots */}
    <circle cx="8"  cy="11" r="1.8" fill="#fbbf24" />
    <circle cx="24" cy="11" r="1.8" fill="#fbbf24" />
    <circle cx="16" cy="16" r="2.5" fill="white" />
    <circle cx="16" cy="21" r="1.8" fill="#fbbf24" />
  </svg>
);

export default TuneupLogo;
